export const en = {
  // navigation rail
  nav_home: 'Home',
  nav_all_pages: 'All pages',
  nav_categories: 'Categories',
  nav_recent_changes: 'Recent changes',
  nav_reports: 'Reports',
  nav_map: 'World map',
  nav_random: 'Random page',
  nav_relations: 'Relations',
  nav_aria_label: 'Navigation',
  nav_create_page: 'Create page',
  // sidebar / page list
  sidebar_aria_label: 'Pages',
  sidebar_nav_label: 'Page list',
  // locale switcher
  lang_switcher_label: 'UI language',
  // top bar / search
  search_placeholder: 'Search',
  search_no_results: 'No results.',
  search_empty: 'Nothing found.',
  search_pages_one: '1 page',
  search_pages_many: '{{count}} pages',
  search_loading: 'Loading',
  search_searching: 'Searching',
  // auth / account panel
  auth_login: 'Log in',
  auth_logout: 'Log out',
  auth_register: 'Register',
  auth_change_password: 'Change password',
  auth_moderation: 'Moderation',
  auth_panel_label: 'Contributor',
  auth_login_to_propose: 'Log in to propose an edit.',
  auth_propose_edit: 'Propose edit',
  auth_pending_count: '{{count}} awaiting moderation',
  auth_contributor_access: 'Contributor access',
  auth_account_security: 'Account security',
  auth_email: 'Email',
  auth_password_label: 'Password',
  auth_logging_in: 'Logging in',
  auth_passwords_mismatch: 'Passwords do not match.',
  auth_confirm_password: 'Confirm password',
  auth_creating_account: 'Creating',
  auth_create_account: 'Create account',
  auth_already_have_account: 'Already have an account',
  auth_error_login: 'Could not log in.',
  auth_error_register: 'Could not register.',
  auth_contributor_required: 'Contributor login required.',
  auth_password_account_hint: 'Password can only be changed for the current account.',
  auth_current_password: 'Current password',
  auth_new_password: 'New password',
  auth_saving: 'Saving',
  auth_save: 'Save',
  auth_cancel: 'Cancel',
  auth_new_passwords_mismatch: 'New password and confirmation do not match.',
  auth_password_changed: 'Password changed.',
  auth_error_change_password: 'Could not change password.',
  // graph / relations panel
  graph_relations_title: 'Relations',
  graph_hide_btn: 'Hide relations',
  graph_svg_label: 'Page graph',
  graph_backlinks: 'Backlinks',
  graph_loading: 'Loading relations.',
  graph_empty: 'None yet.',
  // table of contents
  toc_title: 'Contents',
  toc_show: '[show]',
  toc_hide: '[hide]',
  // reader / article
  reader_loading: 'Loading…',
  reader_not_found: 'Page not found',
  reader_stub: 'This page is a stub.',
  reader_read: 'Read',
  reader_edit: 'Edit',
  reader_history: 'History',
  reader_propose_missing: 'Propose this page',
  reader_home: 'Home',
  reader_breadcrumbs_label: 'Breadcrumbs',
  reader_page_loading: 'Loading page.',
  reader_redirected_from: 'Redirected from',
  reader_redirect_loop: 'This page forms a redirect loop.',
  reader_page_empty: 'This page is currently empty.',
  reader_categories_label: 'Categories:',
  reader_published_prefix: 'Published',
  reader_page_stub: 'Stub',
  reader_missing_lang: 'Page not found in {{lang}}.',
  reader_propose_translation: 'Propose translation',
  reader_no_pages: 'No published pages.',
  reader_page_missing: 'Page "{{slug}}" does not exist yet.',
  reader_relevant_label: 'Related pages',
  reader_relevant_page: 'Page',
  reader_relevant_link: 'Link',
  reader_relevant_mutual: 'mutual',
  reader_relevant_inbound: 'links here',
  reader_relevant_outbound: 'link',
  reader_other_langs_label: 'Other languages',
  reader_other_langs: 'Other languages:',
  reader_info: 'Information',
  // page information panel
  page_info_title: 'Page information',
  page_info_revisions: 'Revisions',
  page_info_contributors: 'Contributors',
  page_info_inbound: 'Inbound links',
  page_info_outbound: 'Outbound links',
  page_info_categories: 'Categories',
  page_info_created: 'Created',
  page_info_updated: 'Updated',
  page_info_current_revision: 'Current revision',
  page_info_translations: 'Translations',
  page_info_loading: 'Loading information.',
  page_info_error: 'Could not load page information.',
  page_info_back: '← Read',
  page_info_none: '—',
  // propose / edit
  propose_new_label: 'New proposal',
  propose_edit_label: 'Edit proposal',
  propose_new_title: 'New page',
  propose_edit_title: 'Edit: {{title}}',
  propose_submit: 'Submit proposal',
  propose_cancel: 'Cancel',
  propose_login_required: 'You must be logged in to propose a page.',
  propose_contributor_required: 'Contributor login required.',
  propose_hint: 'Edits are saved as proposals and await moderation.',
  propose_page_loading: 'Loading page for editing.',
  propose_page_not_found: 'Page not found for edit.',
  propose_title_label: 'Title',
  propose_categories_label: 'Categories',
  propose_categories_placeholder: 'Comma-separated, e.g. Lore, War',
  propose_translation_key_label: 'Translation key',
  propose_translation_key_placeholder: 'Shared key linking this page across languages',
  propose_summary_label: 'Brief description',
  propose_summary_placeholder: 'What changed',
  propose_target_page: 'Target page',
  propose_image_label: 'Image',
  propose_upload_label: 'Upload image',
  propose_uploading: 'Uploading image',
  propose_image_hint: 'JPEG, PNG or WebP, up to 10 MB',
  propose_awaiting: 'Awaiting moderation',
  propose_submitting: 'Submitting',
  propose_error_login: 'Log in to submit a proposal.',
  propose_error_expired: 'Session expired. Log in again.',
  propose_error_submit: 'Could not submit proposal.',
  propose_error_upload: 'Could not upload image.',
  // markdown preview
  preview_empty: 'Preview will appear once you start writing.',
  // moderation
  moderation_title: 'Moderation',
  moderation_no_proposals: 'No pending proposals.',
  moderation_queue_title: 'Proposal queue',
  moderation_moderator_required: 'Moderator login required.',
  moderation_moderator_hint: 'Proposal queue is open to editorial roles only.',
  moderation_queue_label: 'Proposal queue',
  moderation_pending_label: 'Pending',
  moderation_queue_loading: 'Loading queue.',
  moderation_load_more_loading: 'Loading',
  moderation_load_more: 'Load more',
  moderation_select: 'Select a proposal from the queue.',
  moderation_approve_loading: 'Publishing',
  moderation_approve: 'Approve',
  moderation_reject_loading: 'Rejecting',
  moderation_reject: 'Reject',
  moderation_diff_loading: 'Loading diff.',
  moderation_back: 'Queue',
  moderation_forbidden: 'No moderation access.',
  moderation_forbidden_hint: 'Requires moderator, superadmin role or wiki moderation scope.',
  moderation_error_load: 'Could not load moderation queue.',
  moderation_error_diff: 'Could not load proposal diff.',
  moderation_error_load_more: 'Could not load next page.',
  moderation_error_session: 'Session expired. Log in again.',
  moderation_error_decision: 'Could not save decision.',
  moderation_confirm_approve: 'approve',
  moderation_confirm_reject: 'reject',
  moderation_confirm: 'Confirm: {{action}} proposal “{{label}}”?',
  moderation_approved: 'Approved: {{label}}.',
  moderation_approved_revision: ' Revision {{id}}.',
  moderation_rejected: 'Rejected: {{label}}.',
  // categories
  categories_title: 'Categories',
  // page indexes
  page_index_all: 'All pages',
  page_index_recent: 'Recent changes',
  page_index_empty: 'No published pages yet.',
  page_index_recent_empty: 'No recent changes yet.',
  page_index_loading: 'Loading pages.',
  page_index_page_count_one: '1 page',
  page_index_page_count_many: '{{count}} pages',
  page_index_updated: 'Updated {{date}}',
  page_index_stub: 'stub',
  // map
  map_title: 'World map',
  map_loading: 'Loading map.',
  map_canvas_label: 'World map',
  map_canvas_links_label: 'Links to world map pages',
  map_preview_title: 'World map',
  map_preview_link_label: 'Go to world map',
  map_preview_canvas_label: 'World map — preview',
  map_filter_label: 'Filter by category',
  map_filter_all: 'All',
  // moderation metadata tooltips
  moderation_meta_lang: 'Content language',
  moderation_meta_group: 'Translation group',
  // moderation proposal kind labels
  moderation_kind_new: 'New page',
  moderation_kind_edit: 'Edit',
  moderation_proposal_label: 'Proposal',
  // markdown preview section heading
  propose_preview_label: 'Preview',
  // propose field labels
  propose_slug_label: 'Slug',
  propose_markdown_label: 'Markdown',
  // revision history
  history_back: '← Read',
  history_title: 'History: {{slug}}',
  history_loading_list: 'Loading history.',
  history_no_revisions: 'No revisions.',
  history_not_all: 'Not all revisions shown.',
  history_loading_revision: 'Loading revision.',
  history_old_version: 'This is an old version of the page.',
  history_compare: 'Compare with current',
  history_hide_compare: 'Hide comparison',
  history_error_load: 'Could not load history.',
  history_error_revision: 'Could not load revision.',
  // categories index
  categories_index_kicker: 'Index',
  categories_loading: 'Loading categories.',
  categories_empty: 'No categories yet.',
  categories_page_count_one: '1 page',
  categories_page_count_many: '{{count}} pages',
  categories_error_load: 'Could not load categories.',
  // category view
  category_kicker: 'Category',
  category_loading: 'Loading pages.',
  category_empty: 'No pages in this category yet.',
  category_load_more_loading: 'Loading…',
  category_load_more: 'More',
  category_error_load: 'Could not load category.',
  // recent changes feed
  recent_changes_title: 'Recent changes',
  recent_changes_loading: 'Loading recent changes.',
  recent_changes_empty: 'No changes yet.',
  recent_changes_load_more: 'More',
  recent_changes_load_more_loading: 'Loading…',
  recent_changes_error_load: 'Could not load recent changes.',
  // reports
  reports_title: 'Reports',
  reports_wanted: 'Wanted pages',
  reports_orphans: 'Orphan pages',
  reports_dead_ends: 'Dead-end pages',
  reports_loading: 'Loading report.',
  reports_empty: 'No pages in this report.',
  reports_error_load: 'Could not load report.',
  reports_count_one: '1 page',
  reports_count_many: '{{count}} pages',
  // site statistics
  nav_stats: 'Statistics',
  stats_title: 'Site statistics',
  stats_published_pages: 'Published pages',
  stats_stub_pages: 'Stub pages',
  stats_total_revisions: 'Total revisions',
  stats_images: 'Uploaded images',
  stats_categories: 'Categories',
  stats_accounts_by_role: 'Accounts by role',
  stats_loading: 'Loading statistics.',
  stats_error_load: 'Could not load statistics.',
  // audit log
  audit_log_title: 'Action log',
  audit_log_loading: 'Loading audit log.',
  audit_log_empty: 'No audit log entries.',
  audit_log_error_load: 'Could not load audit log.',
  audit_action_proposal_approve: 'Approved proposal',
  audit_action_proposal_reject: 'Rejected proposal',
  audit_action_user_role_change: 'Changed user role',
  audit_action_user_scope_change: 'Changed user scopes',
  // watchlist
  nav_watchlist: 'Watchlist',
  watch_follow: 'Follow',
  watch_unfollow: 'Unfollow',
  watch_loading: 'Updating…',
  watch_login_required: 'Log in to follow pages.',
  watchlist_title: 'Watchlist',
  watchlist_empty: 'You are not following any pages yet.',
  watchlist_loading: 'Loading watchlist.',
  watchlist_error_load: 'Could not load watchlist.',
  watch_error_follow: 'Could not follow page.',
  watch_error_unfollow: 'Could not unfollow page.',
  // notifications
  notifications_bell_label: 'Notifications',
  notifications_mark_all_read: 'Mark all read',
  notifications_empty: 'No notifications.',
  notifications_loading: 'Loading notifications.',
  notifications_error_load: 'Could not load notifications.',
  notification_kind_proposal_approved: 'Proposal approved',
  notification_kind_proposal_rejected: 'Proposal rejected',
  notification_kind_page_published: 'Page updated',
  // diff
  diff_no_changes: 'No changes from the base revision.',
  // admin user management (superadmin only)
  nav_admin_users: 'User management',
  admin_users_title: 'User management',
  admin_users_filter_all: 'All users',
  admin_users_filter_moderators: 'Moderators',
  admin_users_col_email: 'Email',
  admin_users_col_name: 'Name',
  admin_users_col_role: 'Role',
  admin_users_col_created: 'Created',
  admin_users_promote: 'Make moderator',
  admin_users_demote: 'Remove moderator',
  admin_users_updating: 'Updating…',
  admin_users_loading: 'Loading users.',
  admin_users_error_load: 'Could not load users.',
  admin_users_error_update: 'Could not update role.',
  admin_users_prev: '← Prev',
  admin_users_next: 'Next →',
  // errors
  error_load_pages: 'Could not load page list.',
  error_load_page: 'Could not load page.',
  error_load_graph: 'Could not load relations.',
  error_search: 'Search unavailable.',
  error_session_expired: 'Session expired. Log in again.',
  error_login_required: 'Login required.',
  error_moderator_required: 'Moderator login required.',
} as const;

export type DictKey = keyof typeof en;
export type DictShape = Record<DictKey, string>;
